const adminLayoutStyle = {
  Height: '100vh',
};

const adminHeaderStyle = {
  padding: 0,
  top: '0',
  position: 'sticky',
  zIndex: '3',
};

const adminContentStyle = {
  // margin: '24px 16px',
  // margin: '8px',
  margin: '4px 0',
  overflow: 'initial',
};

const adminFooterStyle = {};

export {
  adminLayoutStyle,
  adminHeaderStyle,
  adminContentStyle,
  adminFooterStyle,
};
